
import React from "react";

import styles from "../../../styles/opening-hours.module.scss";

import { Checkbox } from "../../../shared/components/Checkbox";
import { Add } from "../../../shared/components/Add";

import WorkingTime from "../../plugins/core/schema/configurations/WorkingTime";
import Horary from "./Horary";

export default class Day extends React.Component {
	constructor(props) {
		super(props);

		this.getPeriodsArray = this.getPeriodsArray.bind(this);
		this.getPeriods = this.getPeriods.bind(this);
		this.toggleActive = this.toggleActive.bind(this);

		const WeekDays = WorkingTime.getWeekDays('pt-br');

		this.state = {
			WeekDays,
			MAX_PERIODS_PER_DAY: 2
		};
	}

	getPeriodsArray(day) {
		const { MAX_PERIODS_PER_DAY } = this.state;
		const { open } = this.props;

		return new Array(Math.min(open.length || 1, MAX_PERIODS_PER_DAY))
			.fill(0, 0, open.length || 1)
			.map((item, itemIndex) => itemIndex + 1);
	}

	getPeriods() {
		const { open, close } = this.props;

		const periods = this
			.getPeriodsArray()
			.map((periodName, periodIndex) => {
				return {
					periodName,
					open: open[periodIndex] || null,
					close: close[periodIndex] || null,
				}
			});

		for (let periodIndex in periods) {
			const hasBefore = periodIndex > 0;
			const hasAfter = periodIndex < (periods.length - 1) && periods.length > 1;

			periods[periodIndex].before = null;
			if (hasBefore) {
				periods[periodIndex].before = periods[periodIndex - 1];
			}

			periods[periodIndex].after = null;
			if (hasAfter) {
				periods[periodIndex].after = periods[periodIndex + 1];
			}

			periods[periodIndex].allowRemove = false;
			if (periodIndex > 0 && periodIndex == periods.length - 1) {
				periods[periodIndex].allowRemove = true;
			}
		};

		return periods;
	}

	toggleActive() {
		const { active } = this.props;
		this.props.onChangeStatus(!active);
	}

	allowNewPeriod() {
		const { MAX_PERIODS_PER_DAY } = this.state;
		if (this.props.nextDay) {
			return false;
		}

		const periods = this.getPeriods();
		if (periods && periods.length > 0 && periods[periods.length - 1].close === '23:45') {
			return false;
		}

		if (periods.length === MAX_PERIODS_PER_DAY) {
			return false;
		}

		return true;
	}

	render() {
		const {
			weeknum,
			active,
			nextDay,
			beforeDay,
			afterDay,
			readOnly,
		} = this.props;

		return (
			<div className={styles.dayContainer}>
				<div className={styles.header}>
					<Checkbox
						name={`day-status-${weeknum}`}
						checked={active}
						onChange={() => {
							this.toggleActive()
						}}
					>
						{this.state.WeekDays[weeknum % 7]}
					</Checkbox>
				</div>

				<div className={styles.periods}>
					{this.getPeriods().map(({ open, close, periodName, before, after, allowRemove }, periodIndex) =>
						<Horary
							key={`horary-d${weeknum}-p${periodIndex}`}
							open={open}
							close={close}
							active={active}
							weeknum={weeknum}

							disabled={readOnly}

							periodName={periodName}
							before={before}
							after={after}

							afterDay={afterDay}
							beforeDay={beforeDay}

							isLast={periodIndex === this.getPeriods().length - 1}
							allowRemove={allowRemove}
							nextDay={nextDay}

							onChangeHorary={(field, value) => this.props.onChangePeriod(periodIndex, field, value)}
							onRemoveHorary={() => this.props.onRemovePeriod(periodIndex)}
						/>
					)}

					{readOnly === false && this.allowNewPeriod() &&
						<Add
							text="Adicionar período"
							className="flex-column align-center"
							onClick={() => this.props.onAddPeriod()}
						/>
					}
				</div>
			</div>
		)
	}

}